import { NarrowLayout, WideLayout } from "source/Layout"

type FormWrapperProps = {
  authenticated: boolean
  children: NonNullable<React.ReactNode>
}

export function FormWrapper({
  authenticated = false,
  children,
}: FormWrapperProps) {
  const LayoutWrapper = authenticated ? WideLayout : NarrowLayout

  return (
    <LayoutWrapper>
      <div className="pc-donation-form d-f fd-c jc-c g-6">{children}</div>
    </LayoutWrapper>
  )
}
